var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCaptivate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#00E778;}\r\n\t.st1{fill:#00120A;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_21_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_23_",
    className: "st0",
    width: 512,
    height: 512
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_25_",
    x: 22.58,
    y: 22.58,
    className: "st1",
    width: 466.97,
    height: 466.97
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_26_",
    className: "st0",
    d: "M203.12,122.32c18.24,0,30.72,0.14,38.44,4.49c1.26,0.7,1.54,1.4,1.54,3.65v31.14 c0,2.81-1.26,2.81-2.1,2.1c-9.54-4.63-20.48-6.17-36.61-6.17c-39.7,0-66.77,30.86-66.77,82.76c0,65.93,38.15,82.06,65.93,82.06 c16.27,0,27.77-0.56,37.31-5.47c1.54-0.7,2.1-0.42,2.1,1.82v30.44c0,2.1-0.28,3.23-1.82,4.35c-10.1,5.75-23.99,5.19-43.77,5.19 C148.13,359.1,101,326.7,101,241.41C100.86,173.66,140.84,122.32,203.12,122.32z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_33_",
    className: "st0",
    d: "M410.58,264.7c0,62.56-44.19,96.23-87.95,96.23c-5.19,0-9.26-0.42-12.2-1.12v47.13 c0,1.4-0.7,2.52-2.52,2.81l-32.26,3.23c-1.96,0.42-2.24-0.7-2.24-2.1v-194c0-4.35-0.7-15.43-0.98-20.06c0-0.7,0-1.82,0.98-2.1 c13.75-5.05,39-13.89,63.4-13.89C386.31,180.67,410.58,217.14,410.58,264.7z M310.43,217.56v109.41c3.79,1.4,8.7,2.1,13.47,2.1 c26.51,0,48.96-21.46,48.96-62.28c0-35.77-16.97-52.88-39.98-52.88C323.33,213.92,316.88,215.74,310.43,217.56z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaptivate);
export default __webpack_public_path__ + "static/media/captivate.c7058bed.svg";
export { ForwardRef as ReactComponent };